import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CopyInput from '../inputs/CopyInput';
import RadioGroup from '../inputs/RadioGroup';
import { getProjectConfig } from '../../redux/selectors/projectConfig';

export default (props) => {
  const [checkedValue, setCheckedValue] = useState('Script (Recommended)');
  const { embedDetails } = useSelector(getProjectConfig);

  let injectCode = embedDetails?.injectCode || '';
  let iframeCode = embedDetails?.iframeCode || '';
  let embed = embedDetails?.iframeURL || '';
  let tabIndex = props.active ? null : '-1';

  const options = [
    {
      name: 'Script (Recommended)',
      value: 'Script (Recommended)',
      activeElement: <CopyInput value={injectCode} tabIndex={tabIndex} className="w-full" />
    },
    {
      name: 'iFrame',
      value: 'iFrame',
      activeElement: <CopyInput value={iframeCode} tabIndex={tabIndex} className="w-full" />
    },
    {
      name: 'Embed link',
      value: 'Embed link',
      activeElement: <CopyInput value={embed} tabIndex={tabIndex} className="w-full" />
    }
  ];

  const onSelectRadioGroup = (e) => {
    setCheckedValue(e);
  };

  return (
    <div>
      <RadioGroup
        options={options}
        checked={checkedValue}
        groupName="newOrExistingTeam"
        onSelect={onSelectRadioGroup}
        type={'radio-list'}
        tabIndex={tabIndex}
        extraClass={`pr-4 ${props.inEditor ? 'mb-4' : ''}`}
        selectedClassName={`pr-4  ${props.inEditor ? 'mb-2' : ''}`}
      />
    </div>
  );
};
